import { createStore, applyMiddleware, compose, combineReducers, Store } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { ApplicationState, configReducer } from './stores/reducers';
import { History } from 'history';
import { storeBuilder } from 'redux-scaffolding-ts';
import { CompaniesStore, CompanyStore, NewCompanyStore } from 'src/stores/companies-store';
import { TimesheetsStore, TimesheetStore, NewTimesheetStore } from 'src/stores/timesheets-store';
import { ProjectsStore, ProjectStore, NewProjectStore, TimesheetProjectsStore, ReportProjectsStore } from 'src/stores/projects-store'
import { ProjectTasksStore, ProjectTaskStore, NewProjectTaskStore, ProjectTasksDropdownStore, NewProjectTasksFromTemplates, ProjectTaskItemsStore } from 'src/stores/projecttasks-store';
import { ProjectMembersStore, ProjectMemberStore, NewProjectMemberStore, ProjectMemberItemsStore } from 'src/stores/projectmembers-store';
import { ProjectTaskAssignmentsStore, ProjectTaskAssignmentStore, NewProjectTaskAssignmentStore } from 'src/stores/projecttaskassignments-store';
import { EmployeesStore, EmployeeStore, NewEmployeeStore, DropDownEmployeesStore, DropDownManagersStore, ReportEmployeesStore } from 'src/stores/employees-store';
import { TooltipStore } from './stores/tooltips-store';
import { EmployeesReportStore } from './stores/employee-report-store';
import { NewProjectTemplateStore, NewTaskTemplateStore, ProjectTemplatesStore, ProjectTemplateStore, TaskTemplatesStore } from './stores/templates-store';
import { RestrictionPlanStore, RestrictionPlansStore, NewRestrictionPlanStore } from './stores/restriction-plans-store';
import { WhatsNewReportStore } from './stores/whats-new-store';
import { LogsStore } from './stores/logs-store';
import timeSheetReducer from "./stores/reducers/TimeSheet";
import { NotificationItemStore, TaskItemStore } from './stores/systemNotifications/notification-store'
import { MyTimesheetsStore } from './stores/my-timesheets-store'
import employeeReducer from './stores/reducers/Employee';
import taskTemplateReducer from './stores/reducers/taskTemplate';

export default function configureStore(history: History, initialState?: ApplicationState) {
    // Build middleware. These are functions that can process the actions before they reach the store.
    const windowIfDefined = typeof window === 'undefined' ? null : window as any;

    // If devTools is installed, connect to it
    const composeEnhancers =
        typeof window === 'object' &&
            (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
            (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
                latency: 0
            }) : compose;

    // define middlewares
    const middlewares = [thunk, routerMiddleware(history)]

    const createStoreWithMiddleware = composeEnhancers(
        applyMiddleware(...middlewares)
    )(createStore);

    // Add repositories
    storeBuilder.addRepository(new LogsStore() as any);
    storeBuilder.addRepository(new WhatsNewReportStore() as any);
    storeBuilder.addRepository(new EmployeesReportStore() as any);
    storeBuilder.addRepository(new ReportEmployeesStore() as any);
    storeBuilder.addRepository(new ReportProjectsStore() as any);
    storeBuilder.addRepository(new TimesheetProjectsStore() as any);
    storeBuilder.addRepository(new TimesheetsStore() as any);
    storeBuilder.addRepository(new TimesheetStore() as any);
    storeBuilder.addRepository(new NewTimesheetStore() as any);
    storeBuilder.addRepository(new CompaniesStore() as any);
    storeBuilder.addRepository(new CompanyStore() as any);
    storeBuilder.addRepository(new NewCompanyStore() as any);
    storeBuilder.addRepository(new ProjectsStore() as any);
    storeBuilder.addRepository(new ProjectStore() as any);
    storeBuilder.addRepository(new NewProjectStore() as any);
    storeBuilder.addRepository(new ProjectTaskItemsStore() as any);
    storeBuilder.addRepository(new ProjectTasksStore() as any);
    storeBuilder.addRepository(new ProjectTaskStore() as any);
    storeBuilder.addRepository(new ProjectMemberItemsStore() as any);
    storeBuilder.addRepository(new ProjectMembersStore() as any);
    storeBuilder.addRepository(new ProjectMemberStore() as any);
    storeBuilder.addRepository(new NewProjectMemberStore() as any);
    storeBuilder.addRepository(new NewProjectTaskStore() as any);
    storeBuilder.addRepository(new ProjectTaskAssignmentsStore() as any);
    storeBuilder.addRepository(new ProjectTaskAssignmentStore() as any);
    storeBuilder.addRepository(new NewProjectTaskAssignmentStore() as any);
    storeBuilder.addRepository(new ProjectTasksDropdownStore() as any);
    storeBuilder.addRepository(new EmployeesStore() as any);
    storeBuilder.addRepository(new EmployeeStore() as any);
    storeBuilder.addRepository(new TooltipStore() as any);
    storeBuilder.addRepository(new NewEmployeeStore() as any);
    storeBuilder.addRepository(new DropDownEmployeesStore() as any)
    storeBuilder.addRepository(new DropDownManagersStore() as any);
    storeBuilder.addRepository(new NewRestrictionPlanStore() as any);
    storeBuilder.addRepository(new RestrictionPlanStore() as any);
    storeBuilder.addRepository(new RestrictionPlansStore() as any);
    storeBuilder.addRepository(new TaskTemplatesStore() as any);
    storeBuilder.addRepository(new NewTaskTemplateStore() as any);
    storeBuilder.addRepository(new ProjectTemplatesStore() as any);
    storeBuilder.addRepository(new NewProjectTemplateStore() as any);
    storeBuilder.addRepository(new NewProjectTasksFromTemplates() as any);
    storeBuilder.addRepository(new ProjectTemplateStore() as any);
    storeBuilder.addRepository(new NotificationItemStore as any)
  storeBuilder.addRepository(new TaskItemStore as any)
  storeBuilder.addRepository(new MyTimesheetsStore as any)
    
    
    
    // Combine all reducers and instantiate the app-wide store instance
    const store = storeBuilder.getStore(initialState, buildRootReducer(), createStoreWithMiddleware as any) as Store<ApplicationState>;

    return store;
}

function buildRootReducer() {
    return combineReducers<ApplicationState>({
        config: configReducer,
        router: routerReducer,
        timeSheet: timeSheetReducer,
        employee: employeeReducer,
        taskTemplate: taskTemplateReducer,
    } as any);
}